// index.tsx
import React from 'react'
import ReactDOM from 'react-dom'
import TimeAndSales from './src/timeAndSales'

ReactDOM.render(<TimeAndSales />, document.getElementById('root'))
